// The page shell for a Launchpad.
//
// On phones the column fills the width, so sections run edge to edge and each
// supplies its own 16px horizontal padding — the same split the app's home
// feed uses, where card sections are padded but scroller sections are not.
//
// Past CONTENT_MAX_WIDTH the column stops growing and centres, which keeps the
// service card at its own 400px cap and leaves section titles, card edges and
// the first tile of every scroller aligned on the same 16px gutter.

/**
 * The `--content-width` token in index.css, which page transitions also slide
 * by. Kept as one value so the animation distance cannot drift from the
 * column it is moving.
 */
export const CONTENT_MAX_WIDTH = "var(--content-width)";

/** HomeView.sectionSpacing = 20. */
const SECTION_SPACING = "gap-4";

export default function LaunchpadLayout(props: { children: React.ReactNode }) {
  return <div className="min-h-screen bg-page">
    <div
      className={`mx-auto flex w-full flex-col ${SECTION_SPACING} py-6`}
      style={{ maxWidth: CONTENT_MAX_WIDTH }}
    >
      {props.children}
    </div>
  </div>
}
